<div class="login-main">
    <div class="login-main-hdr">
        <div class="login-main-hdr-img-ctr">
            <app-login-client-logo></app-login-client-logo>
        </div>
    </div>
    <div class="login-shared-main-body login-main-body">
        <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()" class="login-main-body-identity-form-container">
            <app-alert-error *ngIf="invalidCredentials" [wide]="true">Incorrect email address or password</app-alert-error>
            <app-alert-error *ngIf="invalidEmailAddress" [wide]="true">Email Address is invalid</app-alert-error>
            <div class="login-main-body-intro-text">Use Your Benefits Portal Login Credentials</div>
            <mat-form-field class="login-form-field login-main-form-field">
                <mat-label>Email</mat-label>
                <mat-icon matIconPrefix color="primary" fontSet="fas" fontIcon="fa-user" class="login-input-icon"></mat-icon>
                <input matInput formControlName="emailAddress" />
                <mat-hint align="end"><a routerLink="RecoverEmailAddress">Forgot Email?</a></mat-hint>
            </mat-form-field>

            <mat-form-field class="login-form-field login-main-form-field">
                <mat-label>Password</mat-label>
                <mat-icon matIconPrefix color="primary" fontSet="fas" fontIcon="fa-lock" class="login-input-icon"></mat-icon>
                <input matInput type="password" formControlName="password" />
                <mat-hint align="end"><a routerLink="ResetPassword">Forgot Password?</a></mat-hint>
            </mat-form-field>

            <button mat-button type="submit" class="login-main-submit" (click)="SetInvalidEmailAddress()">LOGIN</button>
        </form>
        <div class="login-main-footer">
            <a [routerLink]="['./SignUp/Start']" *ngIf="allowSignupLink" class="login-main-signup">Create New Account</a>
        </div>
    </div>
</div>